/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GeoJSONPoint } from "./GeoJSONPoint";
import {
  GeoJSONPointFromJSON,
  GeoJSONPointFromJSONTyped,
  GeoJSONPointToJSON,
  GeoJSONPointToJSONTyped,
} from "./GeoJSONPoint";
import type { GeocodingGeoJSONProperties } from "./GeocodingGeoJSONProperties";
import {
  GeocodingGeoJSONPropertiesFromJSON,
  GeocodingGeoJSONPropertiesFromJSONTyped,
  GeocodingGeoJSONPropertiesToJSON,
  GeocodingGeoJSONPropertiesToJSONTyped,
} from "./GeocodingGeoJSONProperties";

/**
 *
 * @export
 * @interface GeocodingGeoJSONFeature
 */
export interface GeocodingGeoJSONFeature {
  /**
   *
   * @type {GeocodingGeoJSONFeatureTypeEnum}
   * @memberof GeocodingGeoJSONFeature
   */
  type: GeocodingGeoJSONFeatureTypeEnum;
  /**
   *
   * @type {GeoJSONPoint}
   * @memberof GeocodingGeoJSONFeature
   */
  geometry: GeoJSONPoint;
  /**
   *
   * @type {GeocodingGeoJSONProperties}
   * @memberof GeocodingGeoJSONFeature
   */
  properties?: GeocodingGeoJSONProperties;
  /**
   * An array of 4 floating point numbers representing the (W, S, E, N) extremes of the features found.
   * @type {Array<number>}
   * @memberof GeocodingGeoJSONFeature
   */
  bbox?: Array<number>;
}

/**
 * @export
 */
export const GeocodingGeoJSONFeatureTypeEnum = {
  Feature: "Feature",
} as const;
export type GeocodingGeoJSONFeatureTypeEnum =
  (typeof GeocodingGeoJSONFeatureTypeEnum)[keyof typeof GeocodingGeoJSONFeatureTypeEnum];

/**
 * Check if a given object implements the GeocodingGeoJSONFeature interface.
 */
export function instanceOfGeocodingGeoJSONFeature(
  value: object,
): value is GeocodingGeoJSONFeature {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("geometry" in value) || value["geometry"] === undefined) return false;
  return true;
}

export function GeocodingGeoJSONFeatureFromJSON(
  json: any,
): GeocodingGeoJSONFeature {
  return GeocodingGeoJSONFeatureFromJSONTyped(json, false);
}

export function GeocodingGeoJSONFeatureFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeocodingGeoJSONFeature {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    geometry: GeoJSONPointFromJSON(json["geometry"]),
    properties:
      json["properties"] == null
        ? undefined
        : GeocodingGeoJSONPropertiesFromJSON(json["properties"]),
    bbox: json["bbox"] == null ? undefined : json["bbox"],
  };
}

export function GeocodingGeoJSONFeatureToJSON(
  json: any,
): GeocodingGeoJSONFeature {
  return GeocodingGeoJSONFeatureToJSONTyped(json, false);
}

export function GeocodingGeoJSONFeatureToJSONTyped(
  value?: GeocodingGeoJSONFeature | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    geometry: GeoJSONPointToJSON(value["geometry"]),
    properties: GeocodingGeoJSONPropertiesToJSON(value["properties"]),
    bbox: value["bbox"],
  };
}
